/**
 * SHER-753: the registration password policy, in one place.
 *
 * Both consumers read this list: the `strongPassword` case in utils/index.jsx, which decides
 * whether the form submits, and the live checklist in components/general/password_requirements.jsx,
 * which tells the user why it will not. Those were two copies of the same four predicates until
 * a review pointed out that a test asserting they agreed was pinning a divergence that should
 * not be possible in the first place.
 *
 * Its own module rather than utils/index.jsx, because the component would otherwise drag in
 * `jose` — ESM that jest does not transform, and the reason the utils tests carry a jose mock.
 *
 * `translationId` lives here too so a rule cannot be added without the label it renders with.
 */
export const PASSWORD_RULES = [
    { key: "length", translationId: "register.common.password.rules.length", test: (v) => v.length >= 8 },
    { key: "uppercase", translationId: "register.common.password.rules.uppercase", test: (v) => /[A-Z]/.test(v) },
    { key: "number", translationId: "register.common.password.rules.number", test: (v) => /[0-9]/.test(v) },
    // Any non-alphanumeric character. The copy names "! @ # ?" as examples only — do not narrow
    // this to match the examples.
    { key: "special", translationId: "register.common.password.rules.special", test: (v) => /[^A-Za-z0-9]/.test(v) },
];

export const meetsPasswordPolicy = (password) => PASSWORD_RULES.every((rule) => rule.test(password || ""));
